// extracted by mini-css-extract-plugin
export default {"root":"applications-components-ProductsApp-pages-products-module__root","rootVTB":"applications-components-ProductsApp-pages-products-module__rootVTB","breadcrumbs":"applications-components-ProductsApp-pages-products-module__breadcrumbs","title":"applications-components-ProductsApp-pages-products-module__title","b2b":"applications-components-ProductsApp-pages-products-module__b2b"};
    if(module.hot) {
      // 1791528099652
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  